import { SVGComponent } from '~types'

const CompletedIcon = (props: SVGComponent) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 33 33"
    {...props}
  >
    <mask id="a" width="2" height="3" x="15" y="0" maskUnits="userSpaceOnUse">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M15.941 0h.499v2.79h-.499V0Z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#0D66FC"
        fillRule="evenodd"
        d="M16.418 2.79 16.417.227a.227.227 0 0 0-.454 0l.001 2.563c.076-.001.151-.006.227-.006.076 0 .152.005.227.006Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#0D66FC"
      fillRule="evenodd"
      d="m15.982 29.61.002 2.563a.227.227 0 0 0 .454-.001l-.002-2.563c-.076.001-.15.006-.227.006-.076 0-.15-.005-.227-.006Z"
      clipRule="evenodd"
    />
    <mask id="b" width="4" height="2" x="29" y="15" maskUnits="userSpaceOnUse">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M29.61 15.941h2.79v.499h-2.79v-.499Z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#b)">
      <path
        fill="#0D66FC"
        fillRule="evenodd"
        d="m32.172 15.963-2.563.001c.002.076.006.151.006.227 0 .076-.004.152-.005.227l2.562-.002a.227.227 0 1 0 0-.453Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#0D66FC"
      fillRule="evenodd"
      d="M2.784 16.21c0-.077.004-.152.005-.227l-2.562.001a.227.227 0 1 0 0 .454l2.563-.002c-.002-.076-.006-.15-.006-.227ZM4.754 27.34a.227.227 0 0 0 .32.321l1.812-1.813a12.993 12.993 0 0 1-.321-.32L4.754 27.34ZM27.648 5.059a.227.227 0 1 0-.322-.32l-1.81 1.813c.109.105.216.212.32.32l1.812-1.813ZM25.848 25.516c-.105.108-.212.216-.32.32l1.813 1.812a.225.225 0 0 0 .32 0 .227.227 0 0 0 0-.322l-1.813-1.81ZM4.738 4.752a.227.227 0 0 0 0 .321l1.814 1.811c.105-.11.212-.216.32-.321L5.06 4.753a.227.227 0 0 0-.32 0ZM22.386 1.472a.227.227 0 1 0-.42-.17l-.958 2.373c.141.055.283.109.422.167l.956-2.37ZM10.017 30.929a.227.227 0 1 0 .42.17l.957-2.374c-.141-.054-.283-.108-.422-.166l-.955 2.37ZM31.099 21.963l-2.373-.957c-.055.141-.109.283-.167.422l2.37.956a.228.228 0 0 0 .17-.421ZM1.302 10.437l2.373.957c.055-.141.109-.283.167-.422l-2.37-.955a.226.226 0 1 0-.17.42ZM28.631 11.16l2.355-1.002a.227.227 0 1 0-.178-.417l-2.355 1.002c.061.137.121.276.178.417ZM3.766 21.242l-2.355 1.002a.227.227 0 0 0 .178.417l2.355-1.002a11.892 11.892 0 0 1-.178-.417ZM10.743 3.945c.138-.062.276-.122.417-.178L10.158 1.41a.226.226 0 1 0-.417.178l1.002 2.356ZM21.66 28.455c-.139.062-.278.121-.418.178l1.002 2.355a.227.227 0 0 0 .417-.177l-1.002-2.356ZM12.938 31.84a.227.227 0 1 0 .445.086l.487-2.515a13.29 13.29 0 0 1-.446-.083l-.486 2.511ZM19.46.563a.227.227 0 1 0-.446-.086l-.487 2.514c.15.026.299.052.447.084L19.46.563ZM.477 13.385l2.514.487c.026-.149.052-.298.083-.445L.563 12.94a.227.227 0 0 0-.086.445ZM31.926 19.014l-2.514-.487c-.027.15-.052.299-.084.447l2.512.486a.227.227 0 0 0 .086-.446ZM27.442 8.88l2.122-1.434a.227.227 0 1 0-.254-.376l-2.122 1.434c.086.124.171.249.254.376ZM4.96 23.52l-2.122 1.433a.228.228 0 0 0 .254.376l2.123-1.434c-.087-.124-.172-.249-.254-.375ZM8.88 4.96 7.447 2.839a.227.227 0 0 0-.377.254l1.434 2.123c.124-.087.249-.172.376-.254ZM23.895 27.188c-.123.086-.249.171-.375.254l1.433 2.122a.226.226 0 0 0 .315.061.227.227 0 0 0 .06-.314l-1.433-2.123ZM25.083 2.92a.227.227 0 1 0-.381-.246l-1.393 2.148c.128.08.257.16.382.244l1.392-2.145ZM7.318 29.478a.227.227 0 1 0 .38.247l1.394-2.148c-.129-.081-.257-.16-.382-.245l-1.392 2.146ZM2.674 7.698l2.148 1.394c.08-.13.16-.258.245-.383L2.92 7.318a.227.227 0 0 0-.246.38ZM29.725 24.702l-2.148-1.393c-.08.128-.16.257-.245.382l2.146 1.392a.226.226 0 1 0 .247-.38ZM29.365 13.623l2.503-.534a.227.227 0 1 0-.094-.443l-2.505.534c.034.147.067.294.096.443ZM3.034 18.775l-2.502.534a.227.227 0 1 0 .094.444l2.504-.534a12.954 12.954 0 0 1-.096-.444ZM13.18 3.13c.147-.034.294-.067.443-.096L13.09.531a.226.226 0 0 0-.269-.174.226.226 0 0 0-.174.269l.534 2.504ZM19.221 29.27c-.147.033-.295.066-.444.095l.534 2.503a.227.227 0 0 0 .444-.095l-.534-2.503Z"
      clipRule="evenodd"
    />
    <path
      stroke="#0D66FC"
      strokeWidth="2.007"
      d="m10.96 17.387 4.174 2.995 6.786-7.839"
    />
  </svg>
)

export default CompletedIcon
